import ClassSelector from "./classSelector";
import { useEffect, useState } from "react";
import { gql, useQuery } from "@apollo/client";
import { Icon } from "@iconify/react/dist/iconify.js";
import settingsIcon from '@iconify/icons-solar/settings-linear';
import planIcon from '@iconify/icons-solar/calendar-outline';
import logoutIcon from '@iconify/icons-solar/logout-2-outline';

const ME_QUERY = gql`
    query Me {
        me {
            ... on Student {
                id
                username
                surname
                lastname
                class {
                    id
                    name
                }
            }
        }
    }
`;

export default function StudentHeader() {
    const { data, loading, error } = useQuery(ME_QUERY);

    const user = data?.me;

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error loading user data: {error.message}</div>;

    return (
        <nav className="bg-white shadow">
            <div className="container mx-auto ">
                <div className="py-2">
                    <div className="flex flex-row items-center w-full py-2 gap-3 text-slate-800">
                        <div className="min-w-[25%]">
                            <p>
                                <span className="text-primary text-xl">
                                    <span className="font-bold uppercase">
                                        {user.lastname}
                                    </span>{" "}
                                    {user.surname}
                                </span>
                            </p>
                            <p className="hidden md:block">
                                Schüler ( {user.class.name} )
                            </p>
                        </div>
                        <div className="ms-auto flex items-center gap-3">
                            <a href="/" className="p-4 hover:bg-neutral-100 rounded-full">
                                <Icon icon={planIcon} width="24" height="24"/>
                            </a>
                            <a href="/settings" className="p-4 hover:bg-neutral-100 rounded-full">
                                <Icon icon={settingsIcon} width="24" height="24"/>
                            </a>
                            <a href="/logout" className="transform rotate-180 p-4 hover:bg-neutral-100 rounded-full">
                                <Icon icon={logoutIcon} width="24" height="24"/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
}
